const bidErrors = {
  AUCTION_ENDED: 9102
};

export const httpErrorCodes = {
  AUTH_FAILED_BAD_CREDENTIALS: 9009,
  CANNOT_PARK_DGN_IN_ACTIVE: 9816
};

export default bidErrors;
